import demandService from '@/service/demand';
import HRService from '@/service/hr';
import Cookies from 'js-cookie';
import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';
import moIndex from '../../store';
import { changeDefaltCity } from './company';


// 获取人均福利分布

const moCity = observable({
  cityType: 'chart',
  cityActive: 'num',
  modelShow: false,
  cityList: <any>[],
  cityNum: 0,
  activeTime: 2022,
  cityTimeList: <any>[],
  cityRecruitList: <any>[],
});

// 切换各城市招聘需求量及变化表格图表

const changeCityType = action(async (val: string) => {
  runInAction(() => {
    moCity.cityType = val;
  });
  const local: any = await localforage.getItem('demand') || {};
  local['cityType'] = val;
  localforage.setItem('demand', local)
});

// 切换各城市招聘需求量及变化tab

const changeCityActive = action(async (val: string) => {
  runInAction(() => {
    moCity.cityActive = val;
  });
  const local: any = await localforage.getItem('demand') || {};
  local['cityActive'] = val;
  localforage.setItem('demand', local)
});

const toggleModel = action((val: boolean) => {
  runInAction(() => {
    moCity.modelShow = val;
  })
})

// 关闭弹框
const changeModel = action(async (val: boolean, arr: any) => {
  const num = arr.filter((res: any) => res.active).length;
  const cityList: any = [];
  arr.forEach((res: any) => {
    if (res.active) {
      cityList.push(res.name);
    }
  })
  const parmes = {
    access_token: Cookies.get('access_token'),
    multi_cities_recruit: cityList,
  }
  await HRService.editUserOption(parmes);
  runInAction(() => {
    moCity.modelShow = val;
    moCity.cityNum = num;
    moCity.cityList = arr;
  });
  const cityLists = await demandService.getCityList({ date: moCity.activeTime })
  runInAction(() => {
    moCity.cityRecruitList = cityLists;
  })
});

// 修改时间

const changeActiveTime = action(async (val: any) => {
  runInAction(() => {
    moCity.activeTime = val;
  })
  const cityList = await demandService.getCityList({ date: val })
  runInAction(() => {
    moCity.cityRecruitList = cityList;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['cityActiveTime'] = val;
  localforage.setItem('demand', local)
})

// 获取时间列表

const getCityTimeList = action(async () => {
  const local: any = await localforage.getItem('demand') || {};
  const cityTimeList = await demandService.getCityTimeList()
  runInAction(() => {
    moCity.cityTimeList = cityTimeList;
    moCity.activeTime = local['cityActiveTime'] ? local['cityActiveTime'] : cityTimeList[cityTimeList.length - 1]
  })
})

// 获取城市招聘需求数据

const getCityList = action(async () => {
  const cityList = await demandService.getCityList({ date: moCity.activeTime })
  runInAction(() => {
    moCity.cityRecruitList = cityList;
  })
})

// 获取城市选项

const getCityOption = action(async () => {
  const list:any = await HRService.getUserOption();
  const arr = moIndex.cityList?.map((res: any) => {
    const item = {
      name: res.name,
      code: res.code,
      active: list?.multi_cities_recruit?.includes(res.name) ? true : false,
    }
    return item;
  })
  const num = arr?.filter((res: any) => res.active).length || 0;
  changeDefaltCity (list?.top_company_city)
  runInAction(() => {
    moCity.cityList = arr;
    moCity.cityNum = num;
  })
})

export default moCity;
export {
  changeCityType, changeCityActive, changeModel, changeActiveTime, getCityTimeList, getCityList, getCityOption, toggleModel,
};
